import {Response, Model, ID} from '@/_metronic/helpers'

export type CustomerEmail = {
  value: string
  mx: boolean
  disposable: boolean
  token: string
  validatedAt?: Date
}

export interface ComputedBalance {
  balance: number;
}

export type CustomerStatus = {
  status: string
  date: Date
  reason?: string
}

export interface Oauth {
  provider: string;
  firstname?: string;
  lastname?: string;
  username?: string;
  uid: string;
  picture: string;
}

export type CustomerIndicators = {
  paid: number
  payouts: number
  trxs: number
  purchases: number
  credit: number
  debit: number
  earnings: {
    trx: number,
    purchase: number
  }
}

export interface IpData {
  ip: string;
  score: number;
  risk: string;
  carrier: string;
  organization: string;
  country: string;
  vpn: boolean
  proxy: boolean;
  tor: boolean
  server: boolean;
  robot: boolean;
  date: Date;
}

export type SponsorshipStatus = {
  date: Date
  status: string
}

export type SponsorshipChannel = {
  channel: string
  url: string
}

export type Sponsorship = {
  cookieHash: string
  commission: number
  key: string
  statuses: SponsorshipStatus[]
  channels: SponsorshipChannel[]
}


export interface SharedUserMatch {
  type: string
  value: string
  date: Date
}

export interface SharedUser {
  userId: ID
  status: string
  username: string
  lastSeen?: Date
  email: string
  balance: number
  matchWith: SharedUserMatch[]
}

export interface Device {
  date: Date
  device: string
  os: string
  browser: string
}

export interface Msisdn {
  value: string
  token?: string
  validatedAt?: Date
  enabled: boolean
  carrier?: string
  label?:string
}

export interface Isp {
  date: Date
  isp: string
}

export type CustomerSettings = {
  purchaseLimit: {
    daily: number
    monthly: number
  }
  disableSupport: boolean
  disableRestrictions: boolean
  otpEnabled: boolean
  maxIsp: number
  maxDevices: number
  maxMsisdn: number
}

export type Customer = Model & {
  firstname?: string
  lastname?: string
  username: string
  avatar: {
    hash: string
    type: string
  }
  email: string
  country: string
  birthdate?: Date
  createdAt: Date
  statuses: CustomerStatus[]
  emails: CustomerEmail[]
  lastSeen?: {
    clientIp: string
    date: Date
    userAgent: string
  },
  settings: CustomerSettings
  sponsorship?: Sponsorship
  balance: number
  shared?: SharedUser[]
  isp: Isp[]
  devices: Device[]
  msisdns: Msisdn[]
  riskyIps: IpData[],
  oauth: Oauth[],
  spent: {
    daily: number
    monthly: number
  }
}

export type CustomersQueryResponse = Response<Array<Customer>>

export const initialCustomer: Customer = {
  username: '',
  email: '',
  avatar: {
    hash: '',
    type: ''
  },
  country: '',
  createdAt: new Date(),
  statuses: [],
  emails: [],
  isp: [],
  msisdns: [],
  devices: [],
  riskyIps: [],
  settings: {
    purchaseLimit: {
      daily: 0,
      monthly: 0
    },
    disableSupport: false,
    disableRestrictions: false,
    otpEnabled: false,
    maxDevices: 0,
    maxMsisdn: 0,
    maxIsp: 0
  },
  oauth: [],
  balance: 0,
  spent: {
    daily: 0,
    monthly: 0
  }
}

export const initialIndicators: CustomerIndicators = {
  paid: 0,
  payouts: 0,
  trxs: 0,
  purchases: 0,
  credit: 0,
  debit: 0,
  earnings: {
    trx: 0,
    purchase: 0
  }
}
